import {
  GET_MACHINE_OVERVIEW_FAIL,
  GET_MACHINE_OVERVIEW_REQUEST,
  GET_MACHINE_OVERVIEW_SUCCESS
} from './action';
import * as queries from './queries';

export function fetchMachinesOverviews(payload) {
  const { limit, page } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_OVERVIEW_REQUEST });
      const variables = {
        pagingOptions: {
          page,
          size: limit
        }
      };
      const clientResponse = await client.query({
        query: queries.getMachinesOverviews,
        variables
      });

      dispatch({
        type: GET_MACHINE_OVERVIEW_SUCCESS,
        payload: clientResponse
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_OVERVIEW_FAIL,
        payload: { error }
      });
    }
  };
}
